import { render } from "./modifyFlowAdd.vue?vue&type=template&id=c8413ee2"
import script from "./modifyFlowAdd.vue?vue&type=script&lang=js"
export * from "./modifyFlowAdd.vue?vue&type=script&lang=js"

import "./modifyFlowAdd.vue?vue&type=style&index=0&id=c8413ee2&lang=css"

import exportComponent from "C:\\Users\\zhang\\Desktop\\loan\\loanweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__